var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHang = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m21.123 16.071-8.428-4.596v-1.394A3.598 3.598 0 1 0 8.198 6.61h1.799a1.805 1.805 0 0 1 3.598.306 1.87 1.87 0 0 1-1.898 1.493.8.8 0 0 0-.8.8v2.267l-8.428 4.596a2.8 2.8 0 0 0-1.241 1.331A2.546 2.546 0 0 0 3.53 21h16.532a2.545 2.545 0 0 0 2.302-3.598 2.8 2.8 0 0 0-1.241-1.33m-1.062 3.13H3.531a.73.73 0 0 1-.73-.728.9.9 0 0 1 .468-.792l8.527-4.65 8.526 4.65a.9.9 0 0 1 .468.792.73.73 0 0 1-.729.728"
})));
export default SvgHang;